import { cn } from '../../utils/cn'

export function DialogFooter(props: DialogFooter.Props) {
  return <div className={cn('flex w-full justify-end gap-2', props.className)} {...props} />
}

export namespace DialogFooter {
  export interface Props extends React.ComponentProps<'div'> {}
}
